import { Button, Input, List, message } from 'antd'
import { useEffect, useState } from 'react'
import apiClient from '../../Utils/apiClient'

export default function DocumentComments({ documentId }) {
  const [comments, setComments] = useState([])
  const [body, setBody] = useState('')

  const load = () => {
    apiClient.get(`comments/document/${documentId}`).then((res) => setComments(res.data?.result || []))
  }

  useEffect(() => {
    if (documentId) {
      load()
    }
  }, [documentId])

  const onPost = () => {
    if (!body.trim()) {
      return
    }

    apiClient.post(`comments/document/${documentId}`, { body }).then(() => {
      setBody('')
      load()
      message.success('Comment added')
    })
  }

  return (
    <div>
      <List
        size="small"
        dataSource={comments}
        renderItem={(item) => (
          <List.Item>
            <strong>{item.email}</strong>: {item.body}
          </List.Item>
        )}
      />
      <Input.TextArea rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Add a comment…" />
      <Button type="primary" size="small" style={{ marginTop: 8 }} onClick={onPost}>
        Post
      </Button>
    </div>
  )
}
